import { VariantTranslationItem } from '@src/app/model/variant-translation-item';
import { GetVariantTranslations_variantTranslations } from '@src/app/generated/GetVariantTranslations';
import { LocalizedStringForVariant } from '@src/app/model/localized-strings';

export class VariantTranslations {
  bpId: string;
  bpName: string;
  variants: VariantTranslationItem[];

  constructor(bpId: string, bpName: string, variants: VariantTranslationItem[]) {
    this.bpId = bpId;
    this.bpName = bpName;
    this.variants = variants;
  }

  public static fromGql(data: GetVariantTranslations_variantTranslations): VariantTranslations {
    return new VariantTranslations(
      data.bpId,
      data.bpName,
      data.variants.map(v => VariantTranslationItem.fromGql(v))
    );
  }

  public static flattenToTranslationJsonFormat(
    variantTranslations: VariantTranslations[]
  ): LocalizedStringForVariant[] {
    return variantTranslations.map(v => v.variants).flat().map((variant) => {
      return {
        groupId: variant.varGroupId,
        values: {
          values: variant.translations.map((t) => {
            return { key: t.key, value: t.value };
          }),
        },
      };
    }
    ) as LocalizedStringForVariant[];
  }
}
